import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from '@chakra-ui/react';

import MainContentContainer from '../containers/main-content-container';
import React from 'react';

function Breadcrumbs({ breadcrumbItems }) {
  return (
    // <MainContentContainer>
    <Box py="10px">
      <Breadcrumb fontSize="12px" fontWeight="500">
        {breadcrumbItems.map((item, index) => (
          <BreadcrumbItem
            key={index}
            isCurrentPage={index === breadcrumbItems.length - 1}
          >
            <BreadcrumbLink href={item.href}>{item.label}</BreadcrumbLink>
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </Box>
    // </MainContentContainer>
  );
}

export default Breadcrumbs;
